var map = {
	"./chrome.svg": 46982,
	"./edge.svg": 27917,
	"./firefox.svg": 77229,
	"./ie.svg": 99613,
	"./opera.svg": 67547,
	"./safari.svg": 97655,
	"./samsung.svg": 73533,
	"./vivaldi.svg": 26110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51613;